import NamedDto from 'modules/base/dto/NamedDto';
import { normalizeScenarioAttributes } from '../component/WhatIfScenarioUtil';

export class WhatIfScenarioEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.whatIf = null;
		/** @type {Object[]|Object} */
		this.attributes = null;
	}

	/**
	 * @typedef {Object} _WhatIfScenarioEditDtoProps
	 * @property {number} whatIf
	 * @property {Object[]|Object} attributes
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _WhatIfScenarioEditDtoProps} WhatIfScenarioEditDtoProps
	 */
	/**
	 *
	 * @param {WhatIfScenarioEditDtoProps} props
	 * @returns {WhatIfScenarioEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.whatIf = props.whatIf;
		this.attributes = normalizeScenarioAttributes(props.attributes);
		return this;
	}
}

export default WhatIfScenarioEditDto;
